import '@chilipiper/kitchensink-shared/stubs'
import { createRoot } from 'react-dom/client'
import { App } from './App'

// eslint-disable-next-line no-console
console.log(`[Kitchensink SPA] build ${__BUILD_SHA__}`)

const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('Missing #root element')

createRoot(rootElement).render(<App />)
